import React, { useState, useEffect } from 'react';
import './Admin.scss'
import user from '../../../assets/images/panel/user.png'
import Header from '../header/Header';
import translate from "../../../utils/locale/language";
import { getUserDriverCount } from '../../../utils/apis/services/api';
import driver from '../../../assets/images/Driver.png';
import userD from '../../../assets/images/UserD.png';
import Titlebar from '../../../components/titlebar/Titlebar';
import List from '../../../components/list/List';
import { useHistory } from 'react-router-dom';

const Admin = () => {
    const history = useHistory();
    const [totalUsers, setTotalUsers] = useState('');
    const [totalDrivers, setTotalDrivers] = useState('');
    const [recentUsers, setRecentUsers] = useState([]);
    const [approvedDrivers, setApprovedDrivers] = useState([]);
    const [activeTab, setActiveTab] = useState("users");
    const listData = activeTab === "users" ? recentUsers : approvedDrivers;
    const totalAppointments = (approvedDrivers || []).length;
    useEffect(() => {
        const loadCount = async () => {
            const res = await getUserDriverCount();
            const data = res?.data?.ResponseData;
            if (data && res?.data?.ResponseCode === 200) {
                setTotalUsers(data.total_users ?? '');
                setTotalDrivers(data.total_drivers ?? '');
                setRecentUsers(Array.isArray(data.recent_users) ? data.recent_users : []);
                setApprovedDrivers(Array.isArray(data.approved_drivers) ? data.approved_drivers : []);
            }
        };
        loadCount();
    }, []);

    return (
        <div className='admin'>
            <Header title={translate('dashboard')} />
            <section className='admin-container'>
                <p className='app-request'>{/*translate('dashboard')*/}</p>
                <div className='admin-list-container'>
                    <div className='admin-card' style={{minHeight: '65px',height: '75px'}}>
                        <div className='admin-date-block'>
                            <p className='admin-date'><img src={userD} alt='user' style={{ height: 42, width: 42 }} /></p>
                            <p className='just-send' >Total Users</p>
                            <p className='admin-date'>{totalUsers}</p>
                        </div>
                        {/* <div className='admin-info'>
                            <img src={user} alt='user' style={{ height: 42, width: 42 }} />
                            <div className='admin-contact'>
                                <p className='admin-name'>Jessica Almi</p>
                                <p>+856 286192864</p>
                            </div>
                        </div> */}
                        {/* <div className='admin-address'>
                            19B, 10th Avenue, Belkin street, Krik, Laos
                   </div> */}
                        <div>
                        </div>
                    </div>
                    <div className='admin-card' style={{minHeight: '65px',height: '75px'}}>
                        <div className='admin-date-block'>
                            <p className='admin-date'><img src={driver} alt='driver' style={{ height: 42, width: 42 }} /></p>
                            <p className='just-food' >Total Drivers</p>
                            <p className='admin-date'>{totalDrivers}</p>
                        </div>
                    </div>
                </div>
                <div className='admin-tab-header'>
                    <button className={activeTab === "users" ? "admin-tab active bg-[#03A8EE] text-white" : "admin-tab bg-[#03A8EE] text-white"} onClick={() => setActiveTab("users")}>Users</button>
                    <button className={activeTab === "drivers" ? "admin-tab active bg-[#03A8EE] text-white" : "admin-tab bg-[#03A8EE] text-white"} onClick={() => setActiveTab("drivers")}>Approved Drivers</button>
                </div>
                <div className='admin-table-wrap'>
                    <table className='admin-table'>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listData.map((item) => (
                                <tr key={item.id}>
                                    <td>
                                        <div className='admin-row-name'>
                                            {/* <img src={item.profile_image || user} alt='user' style={{ height: 32, width: 32 }} /> */}
                                            <span>{item.full_name || "-"}</span>
                                        </div>
                                    </td>
                                    <td>{item.email || "-"}</td>
                                    <td>{item.phone_number || "-"}</td>
                                    <td>{activeTab === "users" ? (item.is_active ? "Active" : "Inactive") : (item.is_approved ? "Approved" : "Pending")}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {/* <div className='today-wrap'>
                    <p className='section-title'>Appointments Today</p>
                    <div className='today-empty'>You haven't any appointment today</div>
                </div> */}
                {/* <p className='section-title'>New Users</p> */}
                {/* <div className='admin-tab-header'>
                    <div className='admin-tab-header-item' style={{width: '350px'}}>
                        <Titlebar
                            onClick1={() => setActiveTab("users")}
                            onClick2={() => setActiveTab("drivers")}
                            active={activeTab === "users" ? 1 : 2}
                            title1="Users"
                            title2="Approved Drivers"
                            from="adminmanager"
                        />
                    </div>
                </div> */}
                {/* <div className='admin-filters'>
                    <span>Sort by:</span>
                    <select><option>Country</option></select>
                    <select><option>State</option></select>
                    <select><option>City</option></select>
                    <select><option>Title</option></select>
                </div> */}
                {/* <section className="shortlisted">
                    {activeTab === "users" ? (
                        <List from="users" data={recentUsers} onClick={() => history.push("/users")} />
                    ) : (
                        <List from="driver" status="approved" data={approvedDrivers} onClick={() => history.push("/drivers")} />
                    )}
                </section> */}
            </section>
        </div>
    )
}

export default Admin